/** Display the server's contract ordinal; never infer it from stage names or payN keys. */
export function paymentLabel(row, zh, fallback = "") {
  const value = row || {};
  const label = String((zh ? value.label || value.zh || value.triggerZh : value.labelEn || value.en || value.triggerEn) || fallback || value.stage || value.key || "");
  if (!Object.prototype.hasOwnProperty.call(value, "paymentNo")) return label;
  const stage = label.replace(/^(?:第\s*\d+\s*笔付款|付款\s*\d+|Payment\s+\d+)\s*(?:[·•:：-]\s*)?/i, "").trim();
  const no = value.paymentNo;
  const prefix = Number.isInteger(no) && no > 0
    ? (zh ? `第 ${no} 笔付款` : `Payment ${no}`)
    : (zh ? "合同期次待核对" : "Contract installment needs review");
  return stage ? `${prefix} · ${stage}` : prefix;
}
